import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationminibusonrent() {



    const cardData = {

keyword: "Outstation Mini Bus on Rent Pune",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Outstation Mini Bus on Rent in Pune for group travel, corporate tours, weddings, school trips, pilgrimages, and long-distance journeys across India. We provide well-maintained mini buses with seating capacities from 18 to 32 passengers, equipped with push-back seats, air conditioning, spacious luggage space, and experienced drivers for smooth highway travel. With doorstep pickup from Pune, flexible one-way and round-trip packages, 24/7 support, and transparent pricing, we ensure a comfortable and hassle-free group travel experience for all outstation destinations.",

topPlaces: [
    {
        title: "Goa Beach Holiday",
        description:
            "Goa is one of the most popular outstation destinations from Pune, famous for its beaches, nightlife, water sports, and scenic coastal roads. Mini buses are ideal for large group trips, corporate outings, wedding tours, and friends’ vacations, ensuring everyone travels together comfortably."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba, attracting devotees from all over India. Outstation mini buses are widely used for group darshan tours, offering a smooth and coordinated travel experience for families and religious groups."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a spiritual and cultural hub known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. It is a popular group travel destination for religious tours, corporate outings, and family trips using mini bus rentals from Pune."
    },
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool climate. It is ideal for group vacations, school tours, and corporate outings, making mini bus travel comfortable for long scenic journeys."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the closest hill stations to Pune, known for monsoon greenery, waterfalls, and scenic viewpoints. They are perfect for short group trips and weekend getaways using mini bus rentals."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Mini buses are commonly used for group spiritual tours, providing comfort and coordination for family religious journeys from Pune."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular group pilgrimage destination where mini buses ensure safe and comfortable travel for devotees and families."
    },
    {
        title: "Alibaug Coastal Tour",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. It is ideal for group outings, corporate trips, and family picnics using mini bus rentals from Pune for a relaxed coastal experience."
    },
    {
        title: "Aurangabad Heritage Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. It is a top group travel destination for educational trips, historical tours, and cultural exploration from Pune."
    },
    {
        title: "Konkan Coastal Trip",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, Harihareshwar, and Tarkarli offers scenic beaches and natural beauty. Mini buses are ideal for long group vacations with comfortable highway travel through the Western Ghats."
    }
],



services: [
{
name: "Mini Bus On Rent in Pune",
description: "Rising Cab Service offers Mini Bus On Rent in Pune for comfortable group travel, family outings, corporate trips, weddings, and events. Our fleet includes well-maintained AC and non-AC mini buses with professional drivers, ensuring safe and reliable travel across Pune and outstation routes."
},
{
name: "Mini Bus Rental Pune",
description: "Book Mini Bus Rental in Pune with Rising Cab Service for hassle-free group transportation. We provide clean vehicles, experienced chauffeurs, flexible rental options, and affordable pricing for all types of local and long-distance journeys."
},
{
name: "AC Mini Bus Hire Pune",
description: "Rising Cab Service provides AC Mini Bus Hire in Pune for comfortable travel in all weather conditions. Perfect for family trips, corporate outings, and tours with spacious seating and professional drivers."
},
{
name: "Luxury Mini Bus On Rent Pune",
description: "Book Luxury Mini Bus On Rent in Pune for premium group travel experience with plush seating, AC interiors, entertainment systems, and highly trained chauffeurs for weddings, corporate events, and long-distance tours."
},
{
name: "25 Seater Mini Bus On Rent Pune",
description: "Rising Cab Service offers 25 Seater Mini Bus On Rent in Pune for medium-large group travel with spacious seating, AC comfort, luggage space, and safe long-distance driving for tours and events."
},
{
name: "32 Seater Mini Bus Hire Pune",
description: "Book 32 Seater Mini Bus Hire in Pune for large group transportation needs such as weddings, corporate tours, and pilgrimages. Enjoy safe, comfortable, and well-managed travel with professional drivers."
},
{
name: "Mini Bus Booking Pune",
description: "Get instant Mini Bus Booking in Pune with Rising Cab Service. We offer quick reservations, flexible packages, and reliable vehicles for all group travel requirements."
},
{
name: "Cheap Mini Bus On Rent Pune",
description: "Rising Cab Service provides Cheap Mini Bus On Rent in Pune with budget-friendly pricing while maintaining safety, comfort, and reliable travel service for all group sizes."
},
{
name: "Pune Mini Bus Service",
description: "Book Pune Mini Bus Service for local and outstation travel with clean vehicles, professional drivers, and affordable pricing suitable for families, corporate teams, and tourists."
},
{
name: "Outstation Mini Bus On Rent Pune",
description: "Rising Cab Service offers Outstation Mini Bus On Rent in Pune for long-distance group travel to Goa, Mahabaleshwar, Shirdi, and more with safe highway driving and comfortable seating."
},
{
name: "Mini Bus for Picnic Pune",
description: "Book Mini Bus for Picnic in Pune for enjoyable group outings to nearby hill stations and tourist spots with safe driving, flexible stops, and comfortable seating."
},
{
name: "Mini Bus for Wedding Pune",
description: "Rising Cab Service provides Mini Bus for Wedding in Pune for guest transportation with punctual service, spacious seating, and well-managed travel arrangements."
},
{
name: "Mini Bus for Corporate Events Pune",
description: "Book Mini Bus for Corporate Events in Pune for employee transport, office tours, and business outings with professional service and timely execution."
},
{
name: "Mini Bus Hire for School Trip Pune",
description: "Rising Cab Service offers Mini Bus Hire for School Trip in Pune with safe drivers, comfortable seating, and strict safety standards for educational tours."
},
{
name: "Tempo Mini Bus On Rent Pune",
description: "Book Tempo Mini Bus On Rent in Pune for flexible group travel options combining comfort and affordability for local and outstation journeys."
},
{
name: "Pune to Goa Mini Bus Rental",
description: "Rising Cab Service provides Pune to Goa Mini Bus Rental for group beach holidays with AC comfort, experienced drivers, and safe long-distance travel."
},
{
name: "Mini Bus for Group Travel Pune",
description: "Book Mini Bus for Group Travel in Pune for family, friends, or corporate groups with spacious seating, reliable service, and comfortable journeys."
},
{
name: "Non AC Mini Bus On Rent Pune",
description: "Rising Cab Service offers Non AC Mini Bus On Rent in Pune for budget-friendly group travel with safe driving and comfortable seating arrangements."
},
{
name: "Mini Bus Hire Pune for Family Trip",
description: "Book Mini Bus Hire in Pune for Family Trip with safe, comfortable, and affordable travel options for vacations and weekend getaways."
},
{
name: "Mini Bus Rental Near Me Pune",
description: "Find Mini Bus Rental Near Me in Pune with quick booking, nearby availability, and reliable service for all group travel needs."
},
{
name: "Tourist Mini Bus On Rent Pune",
description: "Rising Cab Service provides Tourist Mini Bus On Rent in Pune for sightseeing tours, hill station trips, and long-distance travel with comfort and safety."
},
{
name: "Pune Darshan Mini Bus Hire",
description: "Book Pune Darshan Mini Bus Hire for city sightseeing tours with flexible routes, comfortable seating, and experienced drivers."
},
{
name: "Mini Bus Hire for Office Staff Pune",
description: "Rising Cab Service offers Mini Bus Hire for Office Staff in Pune for daily commute, corporate transport, and employee pick-drop services."
},
{
name: "Mini Bus Service in Pimpri Chinchwad",
description: "Book Mini Bus Service in Pimpri Chinchwad for local and outstation group travel with reliable vehicles and professional drivers."
},
{
name: "Mini Bus Rental for Outstation Pune",
description: "Rising Cab Service provides Mini Bus Rental for Outstation Pune for long-distance travel with safe driving, AC comfort, and flexible packages."
},
{
name: "20 Seater Mini Bus On Rent Pune",
description: "Book 20 Seater Mini Bus On Rent in Pune for medium group travel with spacious seating, AC comfort, and professional service."
},
{
name: "Mini Bus for College Picnic Pune",
description: "Rising Cab Service offers Mini Bus for College Picnic in Pune for safe and fun student group outings with reliable transportation."
},
{
name: "Mini Bus Hire for Airport Transfer Pune",
description: "Book Mini Bus Hire for Airport Transfer in Pune for group pick-up and drop services with punctual timing and luggage space."
},
{
name: "Luxury Bus Rental Pune",
description: "Rising Cab Service provides Luxury Bus Rental in Pune for premium group travel with advanced comfort, entertainment, and professional chauffeurs."
},
{
name: "Mini Bus for Religious Tour Pune",
description: "Book Mini Bus for Religious Tour in Pune for pilgrimage trips to Shirdi, Pandharpur, and other spiritual destinations with safe travel."
},
{
name: "Mini Bus for Konkan Trip Pune",
description: "Rising Cab Service offers Mini Bus for Konkan Trip from Pune for beach and coastal travel with scenic routes and comfortable journey."
},
{
name: "Mini Bus Rental in Hinjewadi Pune",
description: "Book Mini Bus Rental in Hinjewadi Pune for IT companies, corporate groups, and local travel needs with reliable service."
},
{
name: "Mini Bus Rental in Kharadi Pune",
description: "Rising Cab Service provides Mini Bus Rental in Kharadi Pune for corporate and family travel with easy booking and comfortable buses."
}
],

tableData: [
["Mini Bus On Rent in Pune","Mini Bus Rental Pune"],
["AC Mini Bus Hire Pune","Luxury Mini Bus On Rent Pune"],
["25 Seater Mini Bus On Rent Pune","32 Seater Mini Bus Hire Pune"],
["Mini Bus Booking Pune","Cheap Mini Bus On Rent Pune"],
["Pune Mini Bus Service","Outstation Mini Bus On Rent Pune"],
["Mini Bus for Picnic Pune","Mini Bus for Wedding Pune"],
["Mini Bus for Corporate Events Pune","Mini Bus Hire for School Trip Pune"],
["Pune to Goa Mini Bus Rental","Mini Bus for Group Travel Pune"],
["Non AC Mini Bus On Rent Pune","Mini Bus Hire Pune for Family Trip"],
["Mini Bus Rental Near Me Pune","Tourist Mini Bus On Rent Pune"],
["Mini Bus Hire for Office Staff Pune","Mini Bus Service in Pimpri Chinchwad"],
["Mini Bus Rental for Outstation Pune","Mini Bus Hire for Airport Transfer Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Outstation Mini Bus on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable outstation mini bus rental services from Pune for family vacations, corporate tours, pilgrimage trips, educational excursions, and group travel."
    },
    {
        WhyChooseheading: "Perfect for Group Travel Requirements",
        WhyChoosedescription: "Our mini buses are ideal for large families, wedding guests, corporate teams, school groups, friends' outings, and tourist groups traveling together."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Choose from 17 Seater, 20 Seater, 25 Seater, 32 Seater, and other mini bus options according to your group size and travel plans."
    },
    {
        WhyChooseheading: "Outstation Tours Across Maharashtra and India",
        WhyChoosedescription: "Mini buses are available for Mahabaleshwar, Goa, Shirdi, Nashik, Lonavala, Kolhapur, Konkan, Ujjain, Hyderabad, Bangalore, and many other destinations."
    },
    {
        WhyChooseheading: "AC and Non-AC Mini Bus Availability",
        WhyChoosedescription: "Customers can select air-conditioned and non-air-conditioned mini buses based on travel comfort preferences and budget requirements."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Mini bus pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and surrounding locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our professional drivers ensure safe highway travel, smooth journeys, and comfortable transportation throughout the trip."
    },
    {
        WhyChooseheading: "Customized Outstation Tour Packages",
        WhyChoosedescription: "Customers can choose one-way trips, round-trip journeys, weekend tours, pilgrimage packages, sightseeing tours, and multi-day travel plans."
    }
]
};

const faqData = [
    {
        question: "What is Outstation Mini Bus on Rent in Pune?",
        answer: "It is a group transportation service that provides mini buses from Pune for outstation tours, family vacations, corporate travel, pilgrimages, and sightseeing trips."
    },
    {
        question: "Which mini bus seating capacities are available?",
        answer: "We provide 17 Seater, 20 Seater, 25 Seater, 32 Seater, and other mini bus options based on customer requirements."
    },
    {
        question: "Can I hire a mini bus for outstation destinations?",
        answer: "Yes, mini buses are available for destinations across Maharashtra and various states throughout India."
    },
    {
        question: "Are AC mini buses available for long-distance travel?",
        answer: "Yes, fully air-conditioned mini buses are available for comfortable outstation journeys."
    },
    {
        question: "Can families hire mini buses for vacations?",
        answer: "Yes, mini buses are one of the most preferred options for family holidays, group tours, and sightseeing trips."
    },
    {
        question: "Do you provide mini buses for pilgrimage tours?",
        answer: "Yes, we provide mini buses for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga tours, and other religious destinations."
    },
    {
        question: "Can corporate groups rent mini buses?",
        answer: "Yes, mini buses are frequently used for employee transportation, company outings, conferences, and corporate events."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, return journeys, and customized outstation travel packages."
    },
    {
        question: "Do you provide mini buses for school and college trips?",
        answer: "Yes, mini buses are available for educational tours, industrial visits, picnics, and student excursions."
    },
    {
        question: "How can I book an Outstation Mini Bus on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sachin More",
        feedback:
            "We rented a mini bus for our family trip to Goa. The vehicle was spacious, comfortable, and the entire journey was managed professionally from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Deepali Jadhav",
        feedback:
            "Our corporate outing to Mahabaleshwar was organized perfectly. The mini bus was clean, the driver was experienced, and the travel experience was excellent for the whole team.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Outstation Mini Bus on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/outstation-mini-bus-pune.jpg",
"description": "Book Outstation Mini Bus on Rent in Pune with Rising Cab Service for group tours, corporate travel, weddings, and picnic trips. Choose from 25 to 32 seater AC and luxury mini buses for safe and comfortable long-distance journeys.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹25/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/outstation-mini-bus-on-rent-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Outstation Mini Bus on Rent in Pune | 25–32 Seater Group Travel | +91 9272511548</title>

<meta
 name="description"
 content="Book Outstation Mini Bus on Rent in Pune for group tours, weddings, corporate trips, and picnic travel. Get 25–32 seater AC and luxury mini buses for safe long-distance journeys."
/>

<meta
 name="keywords"
 content="mini bus on rent in pune, mini bus rental pune, ac mini bus hire pune, luxury mini bus on rent pune, 25 seater mini bus on rent pune, 32 seater mini bus hire pune, mini bus booking pune, cheap mini bus on rent pune, pune mini bus service, outstation mini bus on rent pune, mini bus for picnic pune, group travel bus pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationminibusonrent;